import React, { useEffect } from "react";
import { Provider } from "react-redux";
import AppRoute from "./routes/index";
import configureStore from "./redux/configureStore";
import AuthProvider from "./providers/AuthProvider";
import AuthRoutes from "./routes/AuthRoutes";
import { createTheme, CssBaseline, ThemeProvider } from "@material-ui/core";
import { ToastContainer } from "react-toastify";

const store = configureStore();

const App = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);
	const theme = createTheme({
		typography: {
			fontFamily: ["Arial", "Helvetica", "sans-serif"].join(","),
		},
	});

	return (
		<Provider store={store}>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				<AuthRoutes />
				{window.location.pathname !== "/login" && (
					<AuthProvider>
						<AppRoute />
					</AuthProvider>
				)}
				<ToastContainer />
			</ThemeProvider>
		</Provider>
	);
};

export default App;
